import ko from "knockout";
import ViewModelTyped from "viewModels/ViewModelTyped";
import PlaybackView from "viewModels/PlaybackView";
import localeService from "services/localeService";
import { getDecodedQueryParamsFromWindow } from "util/uriUtil";
import {
    initNewRelicActionTextOverride,
    cleanupNewRelicActionTextOverride,
} from "util/newRelicActionText";

export type PlaybackContext = "admin" | "agent";

export default class App extends ViewModelTyped {
    private _mainView: ko.Observable<any> = ko.observable();

    readonly mainView: ko.Computed<any> = ko.pureComputed(() =>
        this._mainView()
    );

    readonly appLocale = ko.observable(localeService.getAppLocale());

    private _mainTemplate: ko.Observable<string> =
        ko.observable("templates/loading");

    readonly mainTemplate: ko.Computed<string> = ko.pureComputed(() =>
        this._mainTemplate()
    );

    constructor() {
        super();
        localeService.onLocaleChanged.subscribe(() => {
            this.appLocale(localeService.getAppLocale());
        });
    }

    /**
     * Initialize New Relic actionText override.
     * Should be called after the DOM is ready.
     */
    initNewRelicActionTextOverride(): void {
        initNewRelicActionTextOverride();
    }

    onDispose(): void {
        cleanupNewRelicActionTextOverride();
    }

    private changeView = (viewModel: any, templatePath: string) => {
        this._mainView(viewModel);
        this._mainTemplate(templatePath);
    };

    activateNotFoundView() {
        return this.changeView(undefined, "templates/errors/404");
    }

    activateLoadingView() {
        return this.changeView(undefined, "templates/loading");
    }

    private activatePlaybackView(
        conversationId: string,
        playbackContext: PlaybackContext
    ) {
        const mainView = this.mainView();
        const shouldConstructPlaybackView =
            !mainView ||
            (mainView &&
                mainView.conversationId &&
                mainView.conversationId() !== conversationId) ||
            mainView.playbackContext() !== playbackContext;
        if (shouldConstructPlaybackView) {
            this.changeView(
                new (PlaybackView as any)(conversationId, { playbackContext }),
                "templates/playback"
            );
        }

        const { evaluationId, surveyId } = getDecodedQueryParamsFromWindow();
        this.mainView().evaluationId(evaluationId);
        this.mainView().surveyId(surveyId);

        return this.mainView();
    }

    activateAdminPlaybackView(conversationId: string) {
        return this.activatePlaybackView(conversationId, "admin");
    }

    activateAgentPlaybackView(conversationId: string) {
        return this.activatePlaybackView(conversationId, "agent");
    }
}
